/**
 * Created by mvasim on 12/9/17.
 */

/**
 * This class is used to create table coloum MetaData Object.
 */
export class FnTableMetaData {
  key: string;
  description: string;
  type?: string;
  htmlTxtKey?: string;
  isDisable?: boolean;
  className?: string;
  isSortable = true;
  sortCls?: string;
  sortValue?: number;
  isHidden?: boolean;
  rowDataClass?: string;
  isShowFooter?: boolean;
}
